import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceToOffer } from '../../../core/models/healthSystem/serviceToOffer';
import { CommonService } from '../../../core/services/v2/common.service';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-practice-service',
  templateUrl: './practice-service.component.html',
  styleUrls: ['./practice-service.component.scss']
})
export class PracticeServiceComponent implements OnInit {
  healthsystemId: number;
  isParams: boolean;
  showAddServices: boolean = false;
  servicesList = [];
  serviceTypes: ServiceToOffer[];
  tempServiceTypes: ServiceToOffer[];
  updatedServiceTypes: ServiceToOffer[];
  selectedServiceId: number;
  patientId: number;
  constructor(private _practiceService: PracticeService,
    private _route: ActivatedRoute,
    private readonly changeDetector: ChangeDetectorRef, private commonService: CommonService,
    private _loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getParams();
    if (this.patientId > 0) {
      this.showAddServices = false;
    }
    this.getServiceTypes();
    this.setHealthSystemId();
  }
  getParams() {
    this._route.params.subscribe(
      (params) => {
        this.patientId = params["patientId"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
 
  setHealthSystemId() {
    this._route.params.subscribe(
      (params) => {

        this.isParams = params["id"];
        this.healthsystemId = +params["id"];
        this.getAllServices();
      },
      (error) => {
        console.error(error);
      }
    );
  }
  async getAllServices() {
    await this._practiceService.gethealthSystemServices(this.healthsystemId).subscribe((result) => {
      if (result.resultStatus.isSuccess) {
        for (let i = 0; i < result.result.length; i++) {
          this.servicesList[i] = { id: result.result[i].id, name: result.result[i].name, description: result.result[i].description };
          this.changeDetector.detectChanges();
        }
      }
    });
  }
  addNewService() {
    this.selectedServiceId = 0;
    this.showAddServices = true;
  }
  showEditServicePage(i) {
    this.showAddServices = true;
    this.selectedServiceId = this.servicesList[i].id;

  }
  deleteService(i) {
    this._loaderService.show();

    this._practiceService.deleteHealthSystemServiceById(this.servicesList[i].id, this.healthsystemId).subscribe(
      (_) => {
        this.getAllServices();
      },
      (error) => {

        this._loaderService.hide();
        console.error(error);
      },
      () => {
        this._loaderService.hide();
      }
    );
  }
  optionClicked(serviceId: number) {
    this.selectedServiceId = serviceId;
  }
  onSave() {
    const ids = [];
    this.servicesList.filter((ele) => ids.push(ele.id));
    if (ids.indexOf(this.selectedServiceId) == -1) {
      ids.push(this.selectedServiceId);
    }
    else {
      this._snackBar.open(
        "Selected Service already exists!",
        "Ok",
        {
          duration: 5000,
        }
      );
      return false;
    }

    const req = {
      healthSystemId: this.healthsystemId,
      HealthSystemServicesToOffer: ids,
    };
    this._loaderService
      .blockWithLoader(this._practiceService.updateHealthSysServices(req))
      .subscribe(
        (res) => {
          if (res.isSuccess) {
            this._snackBar.open("Services were successfully updated", "Ok", {
              duration: 5000,
            });

            this.getAllServices();
            this.showAddServices = false;

          } else {
            console.error(res);
            this._snackBar.open(`Services were not updated`, "Ok");
          }
        },
        (error) => {
          console.error(error);
          this._snackBar.open(
            `Services could not be updated${error.error && error.error.resultStatus
              ? ": " + error.error.resultStatus.message
              : ""
            }`,
            "Ok",
            {
              duration: 5000,
            }
          );
        }
      );
  }
  showServiceListPage() {
    this.showAddServices = false;
  }
  async getServiceTypes() {
    await this.commonService.getServicesToOffer().subscribe((res) => {
      this.serviceTypes = res.result;
      console.warn("services-------", this.serviceTypes)
    });
  }
 
}
